<template>
  <!-- 工业园平台操作后台头部 -->
  <div class="cheader">
    <div class="bar1" :style="{
      'background-image':
        isSite ? 'linear-gradient(180deg, #255C94 0%, #19315E 81%)' : 'linear-gradient(180deg, #E7F3FF 0%, #98BAF6 0%, #ECF0F4 100%)'
      ,
      'border-bottom': isSite ? 'none' : '1px solid #ccc'
    }">
      <div class="left_logo">
        <div class="logo_img">
          <!-- <img src="@/assets/kangshenglogo.png" v-if="!isSite" alt />
          <img src="@/assets/logos.png" v-if="isSite" alt /> -->
          
          <img src="@/assets/newscreen/logo.png" alt />
        </div>
        <!-- <div class="title" @click="showCompanyCheck($event)">
          <span>{{ company.name }}</span>
          <Icon v-if="userType == 'SUPER_MANAGER' || userType == 'SYSTEM_MANAGER' || userType == 'PARK_MANAGER'"
            type="ios-arrow-down" style="font-size: 2em;" />
        </div> -->
        <!-- 企业列表 -->
        <div class="company_list" v-show="parkShow">
          <ul>
            <li>
              <i-input prefix="ios-search" placeholder="请输入企业关键字" v-model="search.name"
                style="width: auto;margin-left: 1em" />
            </li>
            <li v-for="(item, index) in parkListCom" :key="index" @click="goOtherCompany(item)">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
      <div class="menu_right">
        <div class="user_name">
          欢迎#
          <i>{{ user && typeof user == "object" ? user.username : "请登录" }}</i>
        </div>
        <div style="padding-right: 1em;color: #fff;cursor: pointer" v-if="userType != 'COMPANY_MANAGER'"
          @click="goPickHome">首页</div>
        <Dropdown @on-click="userActive($event)">
          <a href="javascript:void(0)">
            账号设置
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="home" v-if="userType != 'COMPANY_MANAGER'">首页</DropdownItem>
            <DropdownItem name="adminManage" v-if="user && typeof user == 'object' && user.username == 'admin'">后台管理
            </DropdownItem>
            <DropdownItem name="feedback">问题反馈</DropdownItem>
            <DropdownItem name="change">切换账号</DropdownItem>
            <DropdownItem name="modiPass">修改密码</DropdownItem>
            <DropdownItem name="quit">退出登录</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <div style="margin-left: 1em;">
          <zoom></zoom>
        </div>
      </div>

    </div>


    <div class="bar2" :style="{
      'background': isSite ? '#19315E' : '#fff',
      'border-bottom': isSite ? 'none' : '1px solid #ccc', 'border': isSite ? '1px solid rgba(62,86,129,1)' : 'none'
    }">
      <div class="bar2_menu">
        <!-- active为选中class -->
        <!-- 父菜单 -->
        <div v-for="item in menuListFtil" :class="{ active: isSelectMenu.name == item.name, menu_item: true }"
          :key="item.id" @click="selectMenu(item)" @mouseover="openChild(item)" @mouseleave="closeChild()">
          <div class="menu_fa" :style="{ 'color': isSite ? '#fff' : '#515a6e' }">
            {{ item.title }}
            <Icon type="ios-arrow-down" v-if="item.children.length != 0" />
          </div>
          <!-- 子菜单 -->
          <div class="menu_son" v-show="item.children.length != 0 && idOpenSon.name == item.name">
            <ul>
              <li v-for="jtem in item.children" :style="{ color: isSonMenu.name == jtem.name ? '#008dfe' : '#515a6e' }"
                :key="jtem.id" @click="SelectSonMenu(item, jtem)">
                <span>{{ jtem.title }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bar2_right" v-if="homeShow">
        <!-- 如果父菜单没被选中那只能是home首页 -->
        <Icon style="font-size: 2em" @click="goHome" :style="{ color: !isSelectMenu.name ? '#008dfe' : '#515a6e' }"
          type="ios-home-outline" />
      </div>
    </div>
    <Modal v-model="modiPassModal" width="500" title="修改密码">
      <Form :model="passForm" ref="formRef" :label-width="100" :rules="ruleValidate">
        <FormItem label="当前密码:" prop="oldPassword">
          <i-input v-model="passForm.oldPassword" placeholder="请输入当前密码"></i-input>
        </FormItem>
        <FormItem label="新密码:" prop="password">
          <i-input v-model="passForm.password" placeholder="请输入新密码"></i-input>
        </FormItem>
        <FormItem label="确认新密码:" prop="rePassword">
          <i-input v-model="passForm.rePassword" placeholder="请再次输入新密码"></i-input>
        </FormItem>
      </Form>
      <div slot="footer">
        <i-button @click="modiPassModal = false">取消</i-button>
        <i-button type="primary" @click="submitModify">提交修改</i-button>
      </div>
    </Modal>
    <Modal v-model="feedbackModal" width="500" title="问题反馈">
      <Form :model="form1Validate" ref="feedbakFormRef" :label-width="100" :rules="ruleValidate1">
        <FormItem label="反馈标题：" prop="infoTitle">
          <i-input v-model="form1Validate.infoTitle" placeholder="输入标题"></i-input>
        </FormItem>
        <FormItem label="事件时间：" prop="infoTime">
          <DatePicker type="date" placeholder="选择日期" v-model="form1Validate.infoTime"></DatePicker>
        </FormItem>
        <FormItem label="上传截图：" prop="fileUrl">
          <div class="form_upload">
            <Upload multiple type="drag" action="/api/upload?dir=solidWasteAudit" :on-success="upImgSuccess"
              :on-remove="handleRemove" :with-credentials="true">
              <div style="padding: 20px 0;background: #E6EFFF;">
                <img src="@/assets/photo.png" alt="">
                <p style="color: #165DFF;font-size: 14px;">上传文件或照片</p>
              </div>
            </Upload>
          </div>
          <div>
            <ul>
              <li v-for="(item, index) in form1Validate.fileUrl" :key="index"><span class="del_file"
                  @click="removeFile(index)">X</span> {{ item.name
                }}</li>
            </ul>
          </div>
        </FormItem>
        <FormItem label="反馈信息：" prop="content">
          <i-input v-model="form1Validate.content" type="textarea" :rows="2" placeholder="输入信息"></i-input>
        </FormItem>
      </Form>
      <div slot="footer">
        <i-button @click="feedbackModal = false">取消</i-button>
        <i-button type="primary" @click="addFeedbackData">提交反馈</i-button>
      </div>
    </Modal>
  </div>
</template>

<style lang="scss" scope>
.cheader {
  width: 100%;

  .bar1 {
    height: 4em;
    width: 100%;
    background-image: linear-gradient(180deg, #E7F3FF 0%, #98BAF6 0%, #ECF0F4 100%);
    padding-left: 15px;
    /* 标准的语法 */
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    position: relative;

    .left_logo {
      width: auto;
      margin-left: 1em;
      height: 100%;
      display: flex;
      position: relative;
      cursor: pointer;

      .logo_img {
        height: 100%;
        padding: 0.625em 0;

        img {
          height: 100%;
        }
      }

      .title {
        /* line-height: 4em; */
        padding-left: 0.625em;
        color: #fff;
        display: flex;
        align-items: center;

        span {
          font-size: 1.5em;
        }
      }

      .company_list {
        position: absolute;
        left: 1em;
        top: 4em;
        width: 100%;
        z-index: 998;
        background-color: #fff;
        border-radius: 0.25em;
        box-shadow: 0 0 4px #ccc;
        animation: companyShow 0.5s linear;
        height: 700px;
        overflow: auto;

        ul {
          padding: 0.15em 0;

          li {
            padding: 0.25em 0.5em;
            cursor: pointer;
          }

          li:hover {
            background-color: #d5d5d5;
          }
        }
      }

      .company_list::-webkit-scrollbar {
        width: .5em;
      }

      .company_list::-webkit-scrollbar-thumb {
        border-radius: .2em;
        background-color: #21ad8b;
      }

      .company_list::-webkit-scrollbar-track {
        border-radius: .2em;
        background-color: #e7e7e7;
        border: 1px solid #cacaca;
      }
    }

    .menu_right {
      width: auto;
      margin-right: 2em;
      color: #fff;
      display: flex;
      align-items: center;

      .user_name {
        padding-right: 1em;
      }

      a {
        color: #fff;
      }
    }

  }

  .bar2 {
    height: 3em;
    width: 100%;

    .bar2_menu {
      float: left;
      display: flex;
      height: 100%;
      margin-left: 1em;

      .menu_item {
        padding: 0 1em;
        height: 100%;
        color: #515a6e;
        cursor: pointer;
        position: relative;

        .menu_fa {
          width: 100%;
          height: 100%;
          line-height: 3em;
        }

        .menu_son {
          position: absolute;
          z-index: 999;
          left: 0;
          width: 100%;
          height: auto;
          color: #515a6e;
          padding: 0.5em 0;

          ul {
            width: 100%;
            height: auto;
            background-color: #fff;
            border-radius: 3.5px;
            box-shadow: 0 0 4px #888;
            padding: 0.25em 0;

            li {
              text-align: left;
              padding: 0.25em 1em;

              span {
                font-size: 0.875em;
              }
            }

            li:hover {
              background-color: #f3f3f3;
            }
          }
        }
      }

      .menu_item:hover {
        color: #008dfe;
      }

      .active {
        color: #008dfe;
        position: relative;
      }

      .active::after {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 0.125em;
        background-color: #008dfe;
        bottom: 0;
        left: 0;
      }
    }

    .bar2_right {
      float: right;
      width: auto;
      height: 100%;
      padding: 0 2em 0 0;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }

  .bar2::after {
    content: "";
    clear: both;
    display: block;
  }
}

@keyframes companyShow {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>

<script>
import zoom from "../../components/zoom.vue";
import { Role } from "../../util/common/role.js";
import LoadImg from "../../components/Load_img.vue";

export default {
  data() {
    return {
      menuList: [
        {
          title: "站点监测", // 显示作用
          role: "siteDetection:page", // 权限判断 字段
          name: "site", // 选中判断 字段
          urlPath: "/chome/siteDetection", // 非必须字段 主菜单跳转地址
          urlName: "siteDetection", // 非必须字段 主菜单跳转地址
          id: 1,
          children: [] // 必填字段 children必须有
        },
        {
          title: "站点介绍", // 显示作用
          role: "siteDetection:page", // 权限判断 字段
          name: "siteIn", // 选中判断 字段
          urlPath: "/chome/introduce", // 非必须字段 主菜单跳转地址
          urlName: "introduce", // 非必须字段 主菜单跳转地址
          id: 2,
          children: [] // 必填字段 children必须有
        },
        {
          title: "告警中心",
          role: [
            "siteDeviceWarnRuleCompany:page",
            "extConsumerWarnCompany:page",
            "reportCompany:page"
          ],
          name: "warn",
          id: 3,
          children: [
            {
              title: "告警表格",
              role: "extConsumerWarnCompany:page",
              name: "warn_page2",
              urlPath: "/chome/warnTable", // 必须字段 子菜单跳转地址
              urlName: "warnTable", // 必须字段 子菜单跳转地址
              id: 1
            },
            {
              title: "告警图表",
              role: "extConsumerWarnCompany:page",
              name: "warn_page3",
              urlPath: "/chome/warnCharts", // 必须字段 子菜单跳转地址
              urlName: "warnCharts", // 必须字段 子菜单跳转地址
              id: 2
            },
            {
              title: "告警日报",
              role: "reportCompany:page",
              name: "report_page3",
              urlPath: "/chome/reportDaily",
              urlName: "reportDaily", // 必须字段 子菜单跳转地址
              id: 3
            },
            {
              title: "告警规则",
              role: "siteDeviceWarnRuleCompany:page",
              name: "warn_page1",
              urlPath: "/chome/warnRule", // 必须字段 子菜单跳转地址
              urlName: "warnRule", // 必须字段 子菜单跳转地址
              id: 4
            },
          ]
        },
        {
          title: "报表中心",
          role: ["extConsumerCompany:page", "dataManualInput:page"],
          name: "data",
          id: 4,
          children: [
          {
              title: "手工监测",
              role: "dataManualInput:page",
              name: "manualInput",
              urlPath: "/chome/manualInput", // 必须字段 子菜单跳转地址
              urlName: "manualInput", // 必须字段 子菜单跳转地址
              id: 1
            },
            {
              title: "报表表格",
              role: "extConsumerCompany:page",
              name: "report_page1",
              urlPath: "/chome/reportTable", // 必须字段 子菜单跳转地址
              urlName: "reportTable", // 必须字段 子菜单跳转地址
              id: 2
            },
            {
              title: "报表图表",
              role: "extConsumerCompany:page",
              name: "report_page2",
              urlPath: "/chome/reportCharts", // 必须字段 子菜单跳转地址
              urlName: "reportCharts", // 必须字段 子菜单跳转地址
              id: 3
            },
          ]
        },
        {
          title: "固废管理",
          role: ["wasteInfo:page", "wasteSolidInfo:page", "wasteRequest:page", "solidWasteAudit:page"],
          name: "Waste",
          id: 5,
          children: [
            {
              title: "入库申请",
              role: "wasteRequest:page",
              name: "Request",
              urlPath: "/waste/request",
              urlName: "request", // 必须字段 子菜单跳转地址
              id: 1
            },
            {
              title: "一般固废台账",
              role: "wasteSolidInfo:page",
              name: "RecordsSolid",
              urlPath: "/waste/recordsSolid",
              urlName: "recordsSolid", // 必须字段 子菜单跳转地址
              id: 2
            },
            {
              title: "危废台账",
              role: "wasteInfo:page",
              name: "Records",
              urlPath: "/waste/records",
              urlName: "records", // 必须字段 子菜单跳转地址
              id: 3
            },
            {
              title: "固废库存统计",
              role: "wasteInfo:page",
              name: "Statistics",
              urlPath: "/waste/statistics",
              urlName: "statistics", // 必须字段 子菜单跳转地址
              id: 4
            },
            {
              title: "固废月统计",
              role: "wasteInfo:page",
              name: "RecordsCount",
              urlPath: "/waste/recordsCount",
              urlName: "recordsCount", // 必须字段 子菜单跳转地址
              id: 5
            },
            {
              title: "固废日统计",
              role: "wasteInfo:page",
              name: "RecordsCountDay",
              urlPath: "/waste/recordsCountDay",
              urlName: "recordsCountDay", // 必须字段 子菜单跳转地址
              id: 6
            },
            {
              title: "固废核查",
              role: "solidWasteAudit:page",
              name: "solidWasteAudit",
              urlPath: "/waste/solidWasteAudit",
              urlName: "solidWasteAudit", // 必须字段 子菜单跳转地址
              id: 7
            },
            {
              title: "提醒管理",
              role: "wasteInfo:page",
              name: "Reminder",
              urlPath: "/waste/reminder",
              urlName: "Reminder", // 必须字段 子菜单跳转地址
              id: 8
            },
            {
              title: "固废企业管理",
              role: "wasteInfo:page",
              name: "Company",
              urlPath: "/waste/company",
              urlName: "company", // 必须字段 子菜单跳转地址
              id: 9
            },
            {
              title: "固废类型管理",
              role: "wasteSolidInfo:page",
              name: "TypeSolidManage",
              urlPath: "/waste/typeSolidManage",
              urlName: "typeSolidManage", // 必须字段 子菜单跳转地址
              id: 10
            },
            {
              title: "人脸日志",
              role: "wasteInfo:page",
              name: "FaceLog",
              urlPath: "/waste/faceLog",
              urlName: "faceLog", // 必须字段 子菜单跳转地址
              id: 11,
            }
          ]
        },
        {
          title: "巡检中心", // 显示作用
          role: [
            "inspectionCompany:page",
            "inspectionDeviceWorkSheetCompany:page"
          ], // 权限判断 字段
          name: "xunjian", // 选中判断 字段
          id: 6, // 唯一
          children: [
            {
              title: "巡检考勤",
              role: "inspectionCompany:page",
              name: "xunjian_page1",
              urlPath: "/chome/inspection", // 必须字段 子菜单跳转地址
              urlName: "inspection", // 必须字段 子菜单跳转地址
              id: 1
            },
            {
              title: "巡检工单",
              role: "inspectionDeviceWorkSheetCompany:page",
              name: "xunjian_page2",
              urlPath: "/chome/workOrder", // 必须字段 子菜单跳转地址
              urlName: "workOrder", // 必须字段 子菜单跳转地址
              id: 2
            }
          ] // 必填字段 children必须有
        },
        {
          title: "运维事件", // 显示作用
          role: "siteDeviceEventCompany:page", // 权限判断 字段
          name: "waste", // 选中判断 字段
          urlPath: "/chome/waste", // 非必须字段 主菜单跳转地址
          urlName: "waste", // 非必须字段 主菜单跳转地址
          id: 7,
          children: [] // 必填字段 children必须有
        },
        //环保信息
        {
          title: "环保信息",
          role: [
            "environEvaluation:page",
            "ecEvent:page",
            "evaluationApproval:page",
            "eeProcessResult:page",
            "environmentalKnowledgeBase:page",
            "environOther:page",
          ],
          name: "info",
          id: 8,
          children: [
            {
              title: "环保评价",
              role: "environEvaluation:page",
              name: "info_page1",
              urlPath: "/chome/evaluateInfo", // 必须字段 子菜单跳转地址
              urlName: "evaluateInfo", // 必须字段 子菜单跳转地址
              id: 1
            },
            {
              title: "环保批复",
              role: "ecEvent:page",
              name: "info_page2",
              urlPath: "/chome/replyInfo", // 必须字段 子菜单跳转地址
              urlName: "replyInfo", // 必须字段 子菜单跳转地址
              id: 2
            },
            {
              title: "环保奖惩",
              role: "evaluationApproval:page",
              name: "info_page3",
              urlPath: "/chome/rewardInfo", // 必须字段 子菜单跳转地址
              urlName: "rewardInfo", // 必须字段 子菜单跳转地址
              id: 3
            },
            {
              title: "投诉事件",
              role: "eeProcessResult:page",
              name: "info_page4",
              urlPath: "/chome/complaintInfo", // 必须字段 子菜单跳转地址
              urlName: "complaintInfo", // 必须字段 子菜单跳转地址
              id: 4
            },
            {
              title: "环保知识库",
              role: "environmentalKnowledgeBase:page",
              name: "knowledgeBase",
              urlPath: "/chome/knowledgeBase", // 必须字段 子菜单跳转地址
              urlName: "knowledgeBase", // 必须字段 子菜单跳转地址
              id: 5
            },
            {
              title: "其他信息",
              role: "environOther:page",
              name: "info_page5",
              urlPath: "/chome/otherInfo", // 必须字段 子菜单跳转地址
              urlName: "otherInfo", // 必须字段 子菜单跳转地址
              id: 6
            }
          ]
        },
        {
          title: "环境应急",
          role: [
            "environmentalContingency:page",
            "environmentalContingencySupplies:page",
            "environmentalContingencyInfo:page",
            "environmentalEmergencyPlan:page",
          ],
          name: "contingency",
          id: 9,
          children: [
            {
              title: "应急响应流程",
              role: "environmentalContingency:page",
              name: "ec_page1",
              urlPath: "/chome/contingency1", // 必须字段 子菜单跳转地址
              urlName: "contingency1", // 必须字段 子菜单跳转地址
              id: 1
            },
            {
              title: "应急物资",
              role: "environmentalContingencySupplies:page",
              name: "ec_pageSupplies",
              urlPath: "/chome/contingencySupplies", // 必须字段 子菜单跳转地址
              urlName: "contingencySupplies", // 必须字段 子菜单跳转地址
              id: 2
            },
            {
              title: "应急物资分布",
              role: "environmentalContingency:page",
              name: "ec_page2",
              urlPath: "/chome/contingency2", // 必须字段 子菜单跳转地址
              urlName: "contingency2", // 必须字段 子菜单跳转地址
              id: 3
            },
            {
              title: "应急逃生图",
              role: "environmentalContingency:page",
              name: "ec_page3",
              urlPath: "/chome/contingency3", // 必须字段 子菜单跳转地址
              urlName: "contingency3", // 必须字段 子菜单跳转地址
              id: 4
            },
            {
              title: "应急预案",
              role: "environmentalEmergencyPlan:page",
              name: "ec_plan",
              urlPath: "/chome/environmentalEmergencyPlan", // 必须字段 子菜单跳转地址
              urlName: "environmentalEmergencyPlan", // 必须字段 子菜单跳转地址
              id: 5
            },
            {
              title: "应急演练信息",
              role: "environmentalContingencyInfo:page",
              name: "ec_info",
              urlPath: "/chome/contingencyInfo", // 必须字段 子菜单跳转地址
              urlName: "contingencyInfo", // 必须字段 子菜单跳转地址
              id: 6
            },
          ]
        },
        {
          title: "数据统计",
          role: ["bigData:page"],
          name: "bigData",
          id: 10,
          children: [
            {
              title: "正常运行",
              role: "bigData:chart1",
              name: "bigData0",
              urlPath: "/bigData/bigDataCharts",
              urlName: "bigDataCharts", // 必须字段 子菜单跳转地址
              id: 1
            },
            {
              title: "站点告警",
              role: "bigData:chart1",
              name: "bigData1",
              urlPath: "/bigData/bigDataCharts1",
              urlName: "bigDataCharts1", // 必须字段 子菜单跳转地址
              id: 2
            },
            {
              title: "设备告警",
              role: "bigData:chart2",
              name: "bigData2",
              urlPath: "/bigData/bigDataCharts2",
              urlName: "bigDataCharts2", // 必须字段 子菜单跳转地址
              id: 3
            },
            {
              title: "告警时长",
              role: "bigData:chart2",
              name: "bigData3",
              urlPath: "/bigData/bigDataCharts3",
              urlName: "bigDataCharts3", // 必须字段 子菜单跳转地址
              id: 4
            },
            {
              title: "月 告 警",
              role: "bigData:chart3",
              name: "bigData4",
              urlPath: "/bigData/bigDataCharts4",
              urlName: "bigDataCharts4", // 必须字段 子菜单跳转地址
              id: 5
            },
            {
              title: "小时统计",
              role: "bigData:chart4",
              name: "bigData5",
              urlPath: "/bigData/bigDataCharts5",
              urlName: "bigDataCharts5", // 必须字段 子菜单跳转地址
              id: 6
            },
          ]
        },
        {
          title: "软件监控",
          role: ["system:page", "userCompany:page"],
          name: "system",
          id: 11,
          children: [
            {
              title: "系统监控",
              role: "system:page",
              name: "monitor1",
              urlPath: "/system/monitor",
              urlName: "monitor", // 必须字段 子菜单跳转地址
              id: 1
            },
            {
              title: "用户反馈",
              role: "feedBackInfo:page",
              name: "feedbackInfo",
              urlPath: "/chome/feedback",
              urlName: "feedBackInfo", // 必须字段 子菜单跳转地址
              id: 2
            },
          ]
        },
        {
          title: "数据配置",
          role: [
            "system:page",
            "siteCompany:page",
            "siteDeviceCompany:page",
            "rtuCompany:page",
            "piMiddleware:page",
            "flowConstraintCompany:page",
            "siteProcessLineCompany:page"
          ],
          name: "deploy",
          id: 12,
          children: [
            {
              title: "站点配置",
              role: "siteCompany:page",
              name: "deploy_page1",
              urlPath: "/chome/siteDeploy", // 必须字段 子菜单跳转地址
              urlName: "siteDeploy", // 必须字段 子菜单跳转地址
              id: 1
            },
            {
              title: "设备配置",
              role: "siteDeviceCompany:page",
              name: "deploy_page2",
              urlPath: "/chome/deviceDeploy", // 必须字段 子菜单跳转地址
              urlName: "deviceDeploy", // 必须字段 子菜单跳转地址
              id: 2
            },
            {
              title: "数据采集",
              role: "rtuCompany:page",
              name: "deploy_page3",
              urlPath: "/chome/rtuDeploy", // 必须字段 子菜单跳转地址
              urlName: "rtuDeploy", // 必须字段 子菜单跳转地址
              id: 3
            },
            {
              title: "约束配置",
              role: "flowConstraintCompany:page",
              name: "deploy_page5",
              urlPath: "/chome/constraintDeploy", // 必须字段 子菜单跳转地址
              urlName: "constraintDeploy", // 必须字段 子菜单跳转地址
              id: 5
            },
            {
              title: "工艺流程",
              role: "siteProcessLineCompany:page",
              name: "deploy_page6",
              urlPath: "/chome/processDeploy", // 必须字段 子菜单跳转地址
              urlName: "processDeploy", // 必须字段 子菜单跳转地址
              id: 6
            },
            // {
            //   title: "PI数据配置",
            //   role: "piMiddleware:page",
            //   name: "deploy_page7",
            //   urlPath: "/chome/piDeploy", // 必须字段 子菜单跳转地址
            //   urlName: "piDeploy", // 必须字段 子菜单跳转地址
            //   id: 7
            // },
            {
              title: "活性炭配置",
              role: "activatedCharcoal:page",
              name: "deploy_page8",
              urlPath: "/chome/activCharcoDeploy", // 必须字段 子菜单跳转地址
              urlName: "activCharcoDeploy", // 必须字段 子菜单跳转地址
              id: 7
            },
            {
              title: "声光报警配置",
              role: "alarmWarner:page",
              name: "deploy_page9",
              urlPath: "/chome/alarmDeploy", // 必须字段 子菜单跳转地址
              urlName: "alarmDeploy", // 必须字段 子菜单跳转地址
              id: 8
            },
            {
              title: "通知规则配置",
              role: "system:page",
              name: "Notice_Config",
              urlPath: "/chome/noticeConfig", // 必须字段 子菜单跳转地址
              urlName: "noticeConfig", // 必须字段 子菜单跳转地址
              id: 9
            }, {
              title: "用户配置",
              role: "system:page",
              name: "system_page1",
              urlPath: "/chome/cuser",
              urlName: "cuser", // 必须字段 子菜单跳转地址
              id: 10
            },
            {
              title: "角色配置",
              role: "system:page",
              name: "system_page2",
              urlPath: "/chome/crole",
              urlName: "crole", // 必须字段 子菜单跳转地址
              id: 11
            }
          ]
        },
      ],
      roleList: [],
      userType: null,
      /**
       * 控制menu显示的三个变量
       */
      isSelectMenu: {}, // 选中的父菜单
      idOpenSon: {}, // 鼠标移入展开的子菜单
      isSonMenu: {}, // 选中子菜单
      // 公司信息
      company: {
        name: null,
        logo: null
      },
      search: {
        name: null // 设备名
      },
      parkList: [],
      parkShow: false,
      modiPassModal: false,
      feedbackModal: false,
      passForm: {
        oldPassword: null,
        password: null,
        rePassword: null
      },
      ruleValidate: {
        oldPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        rePassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' }
        ]
      },
      // 表单数据
      form1Validate: {
        infoTitle: "", // 标题
        infoTime: "",// 时间
        fileUrl: [], // 附件
        content: "", // 备注信息
      },
      // 验证
      ruleValidate1: {
        infoTitle: [{ required: true, message: "不能为空", trigger: "blur" }],
        infoTime: [{ required: true, message: "不能为空", type: "date" }],
      },
    };
  },
  computed: {
    isSite() {
      return this.$route.name === 'siteDetection'
    },
    user() {
      return this.$store.state.admin.user;
    },
    menuListFtil() {
      return this.menuList.filter((res, index) => {
        let children = res.children.filter(res1 => {
          return this.roleList.indexOf(res1.role) != -1;
        });
        this.menuList[index].children = children;
        if (typeof res.role == "string") {
          return this.roleList.indexOf(res.role) != -1;
        } else {
          return res.children.length != 0;
        }
      });
    },
    parkListCom() {
      return this.parkList.filter(res => {
        if (this.search.name && this.search.name != '') {
          return (res.name != this.company.name) && (res.name.indexOf(this.search.name) >= 0)
        } else {
          return (res.name != this.company.name)
        }
      })
    },
    homeShow() {
      return this.roleList.indexOf("siteDetection:page") != -1
    }
  },
  components: {
    zoom,
    LoadImg
  },
  created() {
    // window.addEventListener("click", () => {
    //   this.parkShow = false;
    // })
    this.parkList = this.$Local.getLocal("bindCompanies", "object");
    this.parkList.sort();
    this.roleList = this.$Local.getLocal("role", "object");
    this.userType = this.$Local.getLocal("user", "object").userType;
    let company = this.$Local.getLocal("bindCompanies", "object");
    if (company && company[0].name) {
      this.company.name = company[0].name;
      if (this.company.logoImgUrl) {
        this.company.logo = company[0].logoImgUrl;
      }
    }
    let path = window.location.pathname;
    let menuList = this.menuList;
    for (let i = 0, length = menuList.length; i < length; i++) {
      let length = menuList[i].children.length;
      if (length != 0) {
        // 如果有子目录
        for (let j = 0; j < length; j++) {
          // 查找是哪个子集
          if (menuList[i].children[j].urlPath == path) {
            this.isSelectMenu = menuList[i];
            this.isSonMenu = menuList[i].children[j];
            break;
          }
        }
      } else {
        if (menuList[i].urlPath == path) {
          // 选中该父级
          this.isSelectMenu = menuList[i];
          break;
        }
      }
    }
  },
  mounted() { },
  methods: {
    upImgSuccess(res, file) {
      if (!res.code) {
        if (typeof (this.form1Validate.fileUrl) == 'string')
          this.form1Validate.fileUrl = JSON.parse(this.form1Validate.fileUrl);
        this.form1Validate.fileUrl.push(file);
      } else {
        this.$Message.warning("文件上传失败");
      }
    },
    removeFile(index) {
      this.form1Validate.fileUrl.splice(index, 1); // 使用splice方法从数组中删除指定索引的元素  
    },
    handleRemove(res) {
      this.form1Validate.fileUrl.splice(
        this.form1Validate.fileUrl.findIndex(item => item.response === res.response),
        1
      )
    },
    addFeedbackData() {
      //增、改操作
      this.$refs.feedbakFormRef.validate(valid => {
        if (valid) {
          let params = this.form1Validate;
          // 表单验证是否通过
          this.$api.Info.postFeedbackAdd({ content: params }, [
            "uuid",
            "company"
          ]).then(res => {
            if (res.code == 0) {
              this.feedbackModal = false;
              this.$Message.success("反馈成功");
            } else {
              this.$Message.warning(res.message);
            }
          });
        }
      });
    },
    submitModify() {
      let user = this.$Local.getLocal("user", "object");
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          this.$api.Deploy.modifyPassword(
            { content: { username: user.username, ...this.passForm } },
            ["uuid", "company"]
          ).then(res => {
            if (res.code == 0) {
              this.modiPassModal = false;
              this.$Message.success("修改成功");
            } else {
              this.$Message.warning(res.message);
            }
          })
        } else {
          // this.$Message.error('Fail!');
        }
      })
    },
    userActive(msg) {
      // 右上角菜单用户操作
      switch (msg) {
        case "change": {
          this.$Local.removeLocal(["user", "role", "bindCompanies"]);
          this.$router.push("/");
          break;
        }
        case "quit": {
          this.$api.A_Park.loginOut(null, [null, null]).then(res => {
            if (res.code == 0) {
              this.$Local.removeLocal(["user", "role", "bindCompanies"]);
              window.sessionStorage.clear();
              this.$router.push("/");
            }
          });

          break;
        }
        case "home": {
          this.$router.push("/home");
          break;
        }
        case "adminManage": {
          this.$router.push("/ahome");
          break;
        }
        case "modiPass": {
          this.modiPassModal = true;
          break;
        }
        case "feedback": {
          this.form1Validate = {
            infoTitle: "", // 标题
            infoTime: "",// 时间
            fileUrl: [], // 附件
            content: "", // 备注信息
          };
          this.$refs.feedbakFormRef.resetFields(); // 清除验证错误
          this.feedbackModal = true;
          break;
        }

      }
    },
    selectMenu(param) {
      //console.log(param);
      // menu切换
      if (param.children.length == 0) this.isSelectMenu = param;
      let path = param.urlPath; // 跳转地址
      if (path) this.$router.push(path);
    },
    openChild(param) {
      // menu鼠标移入显示menu子菜单
      this.idOpenSon = param;
    },
    closeChild() {
      // menu鼠标移出 关闭子菜单
      this.idOpenSon = {};
    },
    SelectSonMenu(param, paramSon) {
      // 子菜单单击事件
      if (paramSon.name === 'ShenCai') {
        window.open(paramSon.urlPath, '_blank');
      } else {
        this.isSelectMenu = param;
        this.isSonMenu = paramSon;
        this.$router.push(paramSon.urlPath);
      }
    },
    goHome() {
      // 到首页 右上角房子单机事件
      this.isSelectMenu = {};
      this.isSonMenu = {};
      this.$router.push("/home");
    },
    // 去园区首页
    goPickHome() {
      this.$router.push("/home");
    },
    showCompanyCheck(e) {
      e.stopPropagation();
      if (this.userType == 'SUPER_MANAGER' || this.userType == 'SYSTEM_MANAGER' || this.userType == "PARK_MANAGER") {
        this.parkShow = !this.parkShow;
      }

    },
    goOtherCompany(item) {
      let bindCompanies = this.$Local.getLocal("bindCompanies", "object"); // 获取用户企业信息
      // 设置数组第一个企业信息标识为uuid(uuid取的是数组第一位)
      bindCompanies.map((prop, index) => {
        // 冒泡排序换位置
        let temp = bindCompanies[0];
        if (prop.name == item.name) {
          bindCompanies[0] = bindCompanies[index];
          bindCompanies[index] = temp;
        }
      });
      // console.log(bindCompanies)
      // bindCompanies[0] = data;
      this.$Local.setLocal("bindCompanies", bindCompanies);
      window.location.reload()
    }
  }
};
</script>